export const BetTypes = {
  PLAYER: 'PlayerBet',
  TIE: 'TieBet',
  BANKER: 'BankerBet',
  SUITED_TIE: 'SuitedTieBet',
  PLAYER_PAIR: 'PlayerPair',
  BANKER_PAIR: 'BankerPair',
  PERFECT_PAIR: 'PerfectPair',
  EITHER_PAIR: 'EitherPair',
  SMALL: 'Small',
  BIG: 'Big',
  PLAYER_UNDER: 'PlayerUnder',
  PLAYER_OVER: 'PlayerOver',
  BANKER_UNDER: 'BankerUnder',
  BANKER_OVER: 'BankerOver',
  SUPER_SIX: 'SuperSix',
  DRAGON_SEVEN: 'Dragon7Bet',
  PANDA_EIGHT: 'Panda8Bet',
  DRAGON_BONUS_PLAYER: 'DragonBonusPlayer',
  DRAGON_BONUS_BANKER: 'DragonBonusBanker',
  NATURAL_PLAYER: 'NaturalPlayer',
  NATURAL_BANKER: 'NaturalBanker',
  TOTALS_1_TO_4: 'Totals1To4',
  TOTALS_5_TO_6: 'Totals5To6',
  TOTALS_7: 'Totals7',
  TOTALS_8: 'Totals8',
  TOTALS_9: 'Totals9',
  DRAGON: 'DragonBet',
  TIGER: 'TigerBet',
  BOWLER: 'BowlerBet',
  BATSMAN: 'BatsmanBet',
  HOME: 'HomeBet',
  AWAY: 'AwayBet',
} as const;

export const MainBetTypes = {
  PLAYER: 'PlayerBet',
  TIE: 'TieBet',
  BANKER: 'BankerBet',
  DRAGON: 'DragonBet',
  TIGER: 'TigerBet',
  BOWLER: 'BowlerBet',
  BATSMAN: 'BatsmanBet',
} as const;

export const SideBetTypes = {
  SUITED_TIE: 'SuitedTieBet',
  PLAYER_PAIR: 'PlayerPair',
  BANKER_PAIR: 'BankerPair',
  PERFECT_PAIR: 'PerfectPair',
  EITHER_PAIR: 'EitherPair',
  SMALL: 'Small',
  BIG: 'Big',
  PLAYER_UNDER: 'PlayerUnder',
  PLAYER_OVER: 'PlayerOver',
  BANKER_UNDER: 'BankerUnder',
  BANKER_OVER: 'BankerOver',
  SUPER_SIX: 'SuperSix',
  DRAGON_BONUS_PLAYER: 'DragonBonusPlayer',
  DRAGON_BONUS_BANKER: 'DragonBonusBanker',
  NATURAL_PLAYER: 'NaturalPlayer',
  NATURAL_BANKER: 'NaturalBanker',
  DRAGON_SEVEN: 'Dragon7Bet',
  PANDA_EIGHT: 'Panda8Bet',
  HOME: 'HomeBet',
  AWAY: 'AwayBet',
} as const;

export const WinningTotalTypes = {
  TOTALS_1_TO_4: 'Totals1To4',
  TOTALS_5_TO_6: 'Totals5To6',
  TOTALS_7: 'Totals7',
  TOTALS_8: 'Totals8',
  TOTALS_9: 'Totals9',
} as const;

export const NaturalBetsTypes = {
  NATURAL_PLAYER: 'NaturalPlayer',
  NATURAL_BANKER: 'NaturalBanker',
} as const;
